export function getImageFromPost(post) {
  if (!post._embedded) return null
  const { 'wp:featuredmedia': featuredMedia } = post._embedded
  return featuredMedia && featuredMedia[0]
}
